import { fetch } from './fetchReducer'
import { labels } from './fetchLabelsReducer'
import { session, strava } from './userReducer'

// TODO: still missing search and labels

export default {
	fetch,
	labels,
	session,
	strava
}



// WEBPACK FOOTER //
// ./src/store/reducers/index.js